import { CreateGameRoomRule } from "@presidents/game-engine/src/game-room";
import { useField } from "formik";
import React from "react";
import styled from "styled-components";
import { RuleDescription, RuleLabels } from "./rule-labels";
import ToggleSwitch from "./ToggleSwitch";

const RuleOptionFieldElement = styled.div`
  & > label {
    padding: var(--spacing-default);
    background-color: hsla(var(--backgroundHSL), 50%);
    border-radius: 5px;
  }
`;

const RuleOptionLabelContainer = styled.span``;
const RuleOptionLabel = styled.div`
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
`;
const RuleOptionDescription = styled.div`
  font-size: 87.5%;
  opacity: 0.5;
  max-width: 375px;
`;

type Props = {
  name: string;
  checked?: boolean;
  type?: string;
  rule: CreateGameRoomRule;
};
const RuleOptionField: React.FC<Props> = ({ rule, ...props }) => {
  const [field] = useField(props);
  const label = (
    <RuleOptionLabelContainer>
      <RuleOptionLabel>{RuleLabels[rule.rule]}</RuleOptionLabel>
      <RuleOptionDescription>
        {RuleDescription[rule.rule]}
      </RuleOptionDescription>
    </RuleOptionLabelContainer>
  );
  return (
    <RuleOptionFieldElement>
      <ToggleSwitch label={label} {...field} />
    </RuleOptionFieldElement>
  );
};

export default RuleOptionField;
